import { Flag } from "lucide-react";
import { Button } from "@/components/ui/button";
import { openReportDialog } from "@/lib/error-report";

/** O botão do cabeçalho: está em todas as páginas, para reportar um problema onde quer que apareça. */
export const ReportProblemTrigger = () => (
  <Button
    type="button"
    variant="ghost"
    size="icon"
    className="h-9 w-9 shrink-0 text-muted-foreground hover:text-foreground"
    title="Reportar um problema"
    aria-label="Reportar um problema"
    onClick={() => openReportDialog()}
  >
    <Flag className="h-[18px] w-[18px]" strokeWidth={1.75} />
  </Button>
);
